export default "/_next/static/images/8ba333b4df1db8c7bf7eeffc89783f1a.jpg";